import React, { useEffect, useCallback, useRef, useState } from 'react';
import { getNotificationsStatus } from 'src/selectors/notification.selector';
import { actionTypes } from 'src/ducks/notifications.duck';
import { useNotificationsContext } from 'src/contexts/notification.context';
import NotificationView from './notification.view';

const Notification: React.FC = () => {
  const { state, actions } = useNotificationsContext();
  const param = { limit: 0, status: undefined };
  const status = useRef(undefined);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(
    async (type?: string) => {
      const parameter = {
        status: type || status.current,
        limit: 0,
      };

      await actions.listGET(parameter);
    },
    [status]
  );

  useEffect(() => {
    fetchData();

    const timer = setInterval(() => {
      fetchData();
    }, 600000);

    return () => {
      clearInterval(timer);
    };
  }, [actions]);

  const handleRefresh = useCallback(
    async (params) => {
      setLoading(true);
      status.current = params?.status ?? undefined;
      await fetchData(status.current);

      setLoading(false);
    },
    [fetchData, status, setLoading]
  );

  return (
    <NotificationView
      data={state.list}
      handleRefresh={handleRefresh}
      loading={
        loading ||
        (!state.list.length &&
          getNotificationsStatus(state, actionTypes.NOTIFICATION_FETCH)
            .fetching)
      }
      total={state.total}
      param={{ ...param, status: status.current }}
    />
  );
};

export default Notification;
